import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-char-line bg-ink-deep px-4 py-10 sm:px-6" data-id="element-126" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto w-full max-w-[42rem] text-center lg:max-w-3xl" data-id="element-127" data-mp="3r9kfz50ppv5y">
        <p className="font-display text-[0.85rem] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-128" data-mp="3mgrc0jd2iqux">
          Basketball Coach System™
        </p>
        <p className="mx-auto mt-2.5 max-w-xl text-[0.74rem] leading-relaxed text-ivory-dim" data-id="element-129" data-mp="3hglsjqgycanx">
          A digital professional coaching resource library for basketball
          coaches. It supports practice organization and coaching decisions and
          does not replace your own judgment, player safety decisions, or the
          rules of your specific league or organization, which always take
          priority.
        </p>
        <p className="mt-4 text-[0.7rem] text-ivory-dim/70" data-id="element-130" data-mp="11rttxkhp78u3">
          © {new Date().getFullYear()} Basketball Coach System™. All rights
          reserved.
        </p>
      </div>
    </footer>;
}